import { render, staticRenderFns } from "./CreateOrderDialog.vue?vue&type=template&id=ba229286&scoped=true"
import script from "./CreateOrderDialog.vue?vue&type=script&lang=js"
export * from "./CreateOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderDialog.vue?vue&type=style&index=0&id=ba229286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba229286",
  null
  
)

export default component.exports